export default __webpack_public_path__ + "574fce5e928894c80fb0a52dfe3d2246.woff2";